import { FC, useMemo } from 'react';
import styled from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

interface BannerProps {
    subtitle?: string;
    title: string;
    desc: string;
    children: JSX.Element[] | JSX.Element | boolean;
    isInner?: boolean;
}

const Banner: FC<BannerProps> = ({ subtitle, title, desc, children, isInner = true }) => {
    const { isMobile } = useGlobal();

    const imageSrc = useMemo(() => {
        if (!isMobile) {
            return 'https://websiteoss.ecoflow.com/upload/image/1741694491847/referral_banner.jpg';
        }
        return 'https://websiteoss.ecoflow.com/upload/image/1741694495578/referral_banner_h5.jpg';
    }, [isMobile]);

    return (
        <div id="referral-banner" className={`${styled.banner}`}>
            <NextImage src={imageSrc} alt={title} aria-label={title} />
            <div className="banner_text">
                {isInner && (
                    <div className={`content`}>
                        {subtitle && <p className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}></p>}
                        <h1 className="title" dangerouslySetInnerHTML={{ __html: title }}></h1>
                        <p className="desc" dangerouslySetInnerHTML={{ __html: desc }}></p>
                        <div className="tools">{children && children}</div>
                    </div>
                )}
                {!isInner && (
                    <div className={`content`}>
                        {subtitle && <p className="subtitle">{subtitle}</p>}
                        <h1 className="title">{title}</h1>
                        <p className="desc">{desc}</p>
                        <div className="tools">{children && children}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Banner;
